/* eslint-disable react/prop-types */
import { Typography } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Loading } from '../../helpers/utils';

const useStyles = makeStyles(() => ({
  resultRow: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: '10px',
  },
  gradeDetails: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
  },
  totalGrade: {
    // color: '#000000',
    fontSize: '13px',
    fontWeight: 'bold',
  },
  resultDetail: {
    // color: '#666666',
    fontSize: '13px',
  },
}));

const ScaleExams = ({ rowData, examModality }) => {
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (examModality) {
      let totalTemp = 0;
      examModality?.grades?.forEach((gradeInfo) => {
        totalTemp += rowData.grade?.[gradeInfo.gradeEn] || 0;
      });
      setTotal(totalTemp);
      setLoading(false);
    }
  }, [examModality]);

  const classes = useStyles();
  if (!loading) {
    return (
      <div className={classes.gradeDetails}>
        {examModality?.grades?.map((gradeInfo) => (
          <div className={classes.resultRow}>
            <Typography className={classes.resultDetail}>
              {gradeInfo.gradeFr}
            </Typography>
            <Typography className={classes.resultDetail}>
              {rowData?.grade?.[gradeInfo.gradeEn] || '0'}
              /
              {gradeInfo.value}
            </Typography>
          </div>
        ))}
        <div className={classes.resultRow}>
          <Typography className={classes.totalGrade}>
            Total :
          </Typography>
          <Typography className={classes.totalGrade}>
            {total}
            /20
          </Typography>
        </div>
      </div>
    );
  }
  return <Loading />;
};

export default ScaleExams;
